<!-- <section id="section-163-1139" class="ct-section">
  <div class="ct-section-inner-wrap">
    <div id="div_block-164-1139" class="ct-div-block">
      <div id="text_block-165-1139" class="ct-text-block">Ordenar por:</div>
      <div id="code_block-166-1139" class="ct-code-block">
        <div id="order_selector">
        <select (change)="selectOrder($event)">
          <option value="01|date|desc">Fecha más reciente</option>
          <option value="02|date|asc">Fecha más antigua</option>
          <option value="03|name|asc">Nombre ascendente</option>
          <option value="04|name|desc">Nombre descendente</option>
        </select>
      </div>
      </div>
    </div>
  </div>
</section> -->

<section class="ct-section">
  <div class="ct-section-inner-wrap">
    <div class="d-flex align-items-center gap-2">
      <div class="ct-text-block">Ordenar por:</div>
      <div id="order_selector">
        <select [value]="selectedValue" (change)="selectOrder($event)">
          <option *ngFor="let opt of options" [value]="opt.value">
            {{ opt.label }}
          </option>
        </select>
      </div>
    </div>
  </div>
</section>
